import React from 'react';
import Page from '../Page';

export const LoadingPlaceholder = ({className, loading}) => {
    return <Page className={ className } loading={ loading } />
}
